import React, { FC, useState, useEffect } from 'react';
import { Driver, UpdateDriverDto } from '../../types/driver.types';

interface EditDriverFormProps {
  driver: Driver;
  onSubmit: (data: UpdateDriverDto) => Promise<void>;
  onCancel: () => void;
}

export const EditDriverForm: FC<EditDriverFormProps> = ({ driver, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState<UpdateDriverDto>({
    name: '',
    phone: '',
    vehicleId: ''
  });
  const [loading, setLoading] = useState(false);

  // Initialize form with driver data
  useEffect(() => {
    setFormData({
      name: driver.name || '',
      phone: driver.phone || '',
      vehicleId: driver.vehicleId || ''
    });
  }, [driver]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await onSubmit(formData);
    } catch (error) {
      console.error('Error updating driver:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-8">
      <h2 className="text-xl font-semibold mb-4">Edit Driver: {driver.name}</h2>
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <input
            type="text"
            name="name"
            placeholder="Driver Name"
            value={formData.name}
            onChange={handleChange}
            className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
          <input
            type="email"
            value={driver.email}
            className="px-4 py-2 border rounded-lg bg-gray-100 cursor-not-allowed"
            disabled
            placeholder="Email (cannot be changed)"
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
          <input
            type="text"
            name="vehicleId"
            placeholder="Vehicle ID"
            value={formData.vehicleId}
            onChange={handleChange}
            className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
          <div className="flex space-x-4 md:col-span-2">
            <button
              type="submit"
              disabled={loading}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50"
            >
              {loading ? 'Updating...' : 'Update Driver'}
            </button>
            <button
              type="button"
              onClick={onCancel}
              className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-400 transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};